$(document).ready(function(){
  var addressText = $(".id-1530152869806 > div.site-footer-block-content").find( "p:contains('Address')" )
  var talkText = $(".id-1530152869806 > div.site-footer-block-content").find( "p:contains('Talk')" )
  var faxText = $(".id-1530152869806 > div.site-footer-block-content").find( "p:contains('Fax')" )
  var emailText = $(".id-1530152869806 > div.site-footer-block-content").find( "p:contains('Email')" )
  var socialText = $(".id-1530152869806").find( "p:contains('Social')" )
  
  var addressIcon = $("<i></i>").addClass( "fa fa-map-marker" ).css( "margin-right", "10px" );
  var talkIcon = $("<i></i>").addClass( "fa fa-phone" ).css( "margin-right", "10px" );
  var faxIcon = $("<i></i>").addClass( "fa fa-fax" ).css( "margin-right", "10px" );
  var emailIcon = $("<i></i>").addClass( "fa fa-envelope" ).css( "margin-right", "10px" );
  var socialIcon = $("<i></i>").addClass( "fa fa-users" ).css( "margin-right", "10px" );
  
  $(addressText).prepend(addressIcon);
  $(talkText).prepend(talkIcon);
  $(faxText).prepend(faxIcon);
  $(emailText).prepend(emailIcon);
  $(socialText).prepend(socialIcon);

});
